// Catalogue des items EDN : lecture du CSV (data/donnees.js), matières, couleurs de badge, index par identifiant.
window.normalizeSpecialty = function(spec) {
    if (!spec) return spec;
    var s = spec.trim();
    var low = s.toLowerCase();
    
    if (s === "Gynécologie" || s === "Gynécologie-Obstétrique" || s === "Gynéco-Obstétrique") return "Gynéco-Obstétrique";
    if (s === "Réanimation" || s === "Réa-Urgences" || s === "Urgence - Anesth-Réa" || s === "Anesth-Réa") return "Réa-Urgences";
    if (s === "Chirurgie viscérale" || s === "Chirurgie digestive" || s === "Chirurgie dig.") return "Chirurgie dig.";
    if (s === "Orthopédie" || s === "Orthopédie-Trauma." || s === "Ortho") return "Orthopédie-Trauma.";
    if (s === "Médecine physique et de réadaptation" || s === "MPR") return "MPR";
    if (s === "Parasitologie" || s === "Infectiologie") return "Infectiologie";
    if (s === "Oncologielogie" || s === "Oncologie") return "Oncologie"; 

    // NOUVELLES FUSIONS INTELLIGENTES :
    if (low.indexOf("gastro") !== -1 || low.indexOf("entérologie") !== -1 || low.indexOf("enterologie") !== -1 || low === "hge") {
        return "HGE";
    }
    if (low.indexOf("orl") !== -1 || low.indexOf("oto") !== -1 || low.indexOf("rhino") !== -1 || low.indexOf("laryngologie") !== -1) {
        return "ORL";
    }
    if (low.indexOf("maxillo") !== -1 || low.indexOf("faciale") !== -1) {
        return "Chirurgie maxillo";
    }
    
    return s;
};

// Six familles de matières, pas trente couleurs : la teinte repère la famille, le nom porte le sens.
// Les classes .mat-* mélangent la teinte à la surface du moment (src/styles/composants.css), donc jour et nuit suivent.
window.FAMILLES_MATIERES = {
    med: ['Cardiologie', 'Pneumologie', 'HGE', 'Gastro-entérologie', 'Néphrologie', 'Endocrinologie', 'Hématologie',
          'Rhumatologie', 'Allergologie', 'Immunologie', 'Médecine interne', 'Dermatologie', 'Oncologie', 'Gériatrie',
          'Nutrition', 'Infectiologie'],
    chir: ['Orthopédie-Trauma.', 'Chirurgie dig.', 'Chirurgie maxillo', 'Neurochirurgie', 'Chirurgie vasculaire',
           'Chirurgie thoracique', 'Urologie', 'ORL', 'Ophtalmologie', 'Anesthésie'],
    mere: ['Pédiatrie', 'Gynéco-Obstétrique'],
    neuro: ['Neurologie', 'Psychiatrie'],
    urg: ['Réa-Urgences', 'Soins palliatifs', 'Douleur', 'MPR'],
    trans: ['Santé publique', 'LCA', 'Médecine légale', 'Médecine du travail', 'Pharmacologie', 'Génétique',
            'Anatomie et cytologie pathologiques', 'Autre'],
};
window.__familleParMatiere = null;
window.familleMatiere = function(matiere) {
    if (!window.__familleParMatiere) {
        window.__familleParMatiere = {};
        Object.keys(window.FAMILLES_MATIERES).forEach(function(f) {
            window.FAMILLES_MATIERES[f].forEach(function(m) { window.__familleParMatiere[m] = f; });
        });
    }
    return window.__familleParMatiere[matiere] || null;
};
window.getSpecialtyStyle = function(matiere) {
    var f = window.familleMatiere(matiere);
    return f ? 'mat mat-' + f : 'mat';
};

window.parseItemsDb = function() {
    var lines = window.RAW_CSV.trim().split('\n');
    var itemsMap = {};
    for (var i = 1; i < lines.length; i++) {
        var parts = lines[i].split(';');
        if (parts.length > 2) {
            itemsMap[parts[1]] = {
                id: parts[1],
                titre: parts[0],
                matiere: window.normalizeSpecialty(parts[2]),
                score: parseInt(parts[3], 10) || 0,
                collegesSecondaires: []
            };
        }
    }
    if (window.CSV_EXCEL) {
        var rawExcel = window.CSV_EXCEL.replace(/\[source:\s*\d+\]\s*/g, '');
        var rows = [];
        var cols = [];
        var inQuotes = false;
        var current = '';
        for (var k = 0; k < rawExcel.length; k++) {
            var c = rawExcel[k];
            if (c === '"') {
                inQuotes = !inQuotes;
            } else if (c === ',' && !inQuotes) {
                cols.push(current);
                current = '';
            } else if (c === '\n' && !inQuotes) {
                cols.push(current);
                rows.push(cols);
                cols = [];
                current = '';
            } else {
                current += c;
            }
        }
        if (current || cols.length > 0) { cols.push(current); rows.push(cols); }

        rows.slice(1).forEach(function(r) {
            if (r.length < 4) return;
            var idEx = r[0] ? r[0].trim() : '';
            var item = itemsMap[idEx];
            if (item) {
                var rawSecList = [];
                if (r[3] && r[3] !== 'X' && r[3] !== '1') rawSecList.push(r[3]);
                if (r[4] && r[4] !== 'X' && r[4] !== '1') rawSecList.push(r[4]);
                if (r[5] && r[5] !== 'X' && r[5] !== '1') rawSecList.push(r[5]);
                if (r[6] && r[6] !== 'X' && r[6] !== '1') rawSecList.push(r[6]);
                
                var secList = [];
                // Découpe uniquement s'il y a un tiret AVEC des espaces pour préserver Gynéco-Obstétrique
                rawSecList.forEach(function(colStr) {
                    var p = colStr.split(' - ');
                    p.forEach(function(sp) {
                        var cleaned = window.normalizeSpecialty(sp);
                        if (cleaned) secList.push(cleaned);
                    });
                });
                
                // Nettoyage absolu des doublons
                var uniqueSecList = [];
                secList.forEach(function(x) {
                    if (x !== item.matiere && uniqueSecList.indexOf(x) === -1) {
                        uniqueSecList.push(x);
                    }
                });
                item.collegesSecondaires = uniqueSecList;
            }
        });
    }
    return Object.values(itemsMap);
};

window.ednsItems = window.parseItemsDb();

var uniqueSpecs = new Set();
window.ednsItems.forEach(function(item) {
    if(item.matiere) uniqueSpecs.add(item.matiere);
    item.collegesSecondaires.forEach(function(s) { uniqueSpecs.add(s); });
});
window.allSpecialties = Array.from(uniqueSpecs).sort();
window.state.selectedSpecs = [].concat(window.allSpecialties);
window.state.orderedSpecialties = [].concat(window.allSpecialties);
window.state.orderedSpecialties2 = [].concat(window.allSpecialties);

window.itemById = function(id) {
    id = String(id);
    if (!window.__itemsIndex || window.__itemsIndexN !== (window.ednsItems || []).length) {
        window.__itemsIndex = {};
        (window.ednsItems || []).forEach(function(i) { window.__itemsIndex[String(i.id)] = i; });
        window.__itemsIndexN = (window.ednsItems || []).length;
    }
    return window.__itemsIndex[id] || null;
};

// Exports : les mêmes fonctions que celles posées sur window (le code historique les lit encore là).
export const normalizeSpecialty = window.normalizeSpecialty;
export const getSpecialtyStyle = window.getSpecialtyStyle;
export const parseItemsDb = window.parseItemsDb;
export const ednsItems = window.ednsItems;
export const allSpecialties = window.allSpecialties;
export const itemById = window.itemById;
